module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-16-2123b74a60c64d28aecd208c6fa9657d.jpg";